import {
	CtaButton,
	type CtaButtonStyleType,
	Icon,
	TextBody,
} from '@tkww/orion-web-ds';
import React, { type FC } from 'react';
import Styles from './styles.scss';

export type Props = {
	icon: string;
	text?: string;
	style: CtaButtonStyleType;
	onClick: () => void;
	color?: Icon.Color;
};

export const BookVendorButton: FC<Props> = ({
	icon,
	text,
	style,
	onClick,
	color,
}) => {
	return (
		<CtaButton
			as="button"
			treatAs="button"
			data-testid="storefront-mark-as-booked-cta"
			styleType={style}
			size="md"
			labelDirection="right"
			onClick={onClick}
			className={Styles.button}
		>
			<div className={Styles.buttonContent}>
				<Icon
					name={icon}
					size="md"
					aria-hidden="true"
					{...(color ? { color } : {})}
				/>
				<TextBody size="sm" className={Styles.buttonText}>
					{text}
				</TextBody>
			</div>
		</CtaButton>
	);
};
